<!-- We need to use an inline style so we can access it through the javascript -->
<!-- That way if one wants to change the default width one would only need to touch here -->
<div #wrapper class="tooltip-wrapper" style="max-width: 404px;" [style.min-width.px]="width">
    <div class="tooltip-content-wrapper">
        <ng-container [ngSwitch]="position">
            <div *ngSwitchCase="tooltipPosition.Bottom" class="top-arrow-pointer-wrapper"
                 [ngStyle]="{'left': cursorOffset+'px', 'right': 'initial'}">
                <div class="top-arrow-pointer"></div>
                <div class="top-arrow-pointer-border"></div>
            </div>
            <div *ngSwitchCase="tooltipPosition.Top" class="bottom-arrow-pointer-wrapper"
                 [ngStyle]="{'left': cursorOffset+'px', 'right': 'initial'}">
                <div class="bottom-arrow-pointer"></div>
                <div class="bottom-arrow-pointer-border"></div>
            </div>
            <div *ngSwitchCase="tooltipPosition.Right" class="left-arrow-pointer-wrapper"
                 [ngStyle]="{'top': cursorOffset+'px', 'bottom': 'initial'}">
                <div class="left-arrow-pointer"></div>
                <div class="left-arrow-pointer-border"></div>
            </div>
            <div *ngSwitchCase="tooltipPosition.Left" class="right-arrow-pointer-wrapper"
                 [ngStyle]="{'top': cursorOffset+'px', 'bottom': 'initial'}">
                <div class="right-arrow-pointer"></div>
                <div class="right-arrow-pointer-border"></div>
            </div>
        </ng-container>

        <div *ngIf="!isHeaderless" class="header">
            <div class="header-content">
                <div class="icon">
                    <i class="material-icons">info</i>
                </div>
                <div class="text">
                    <span #titleEl>{{title}}</span>
                </div>
            </div>
            <div class="close" (click)="close($event)">
                <i class="fa fa-times"></i>
            </div>
        </div>
        <div class="message-wrapper">
            <span [innerHTML]="message" #messageEl></span>
        </div>
    </div>
</div>
